<template>
  <div class="clear-layout">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'clear-layout',
};
</script>

<style lang="scss" scoped>
.clear-layout {
  height: 100vh;
  overflow: hidden;
}
</style>
